<style lang="scss" scoped></style>

<template>
  <div class="btn-group">
    <v-button
      :request="toggleErotic"
      :disabled="entry.is_primary"
      class="btn"
      :class="{
        'btn-warning': !entry.is_erotic,
        'btn-success': entry.is_erotic
      }"
    >
      18+
    </v-button>
    <v-button
      v-if="isFake"
      :request="toggleOnline"
      class="btn"
      :class="{
        'btn-warning': !entry.is_online,
        'btn-success': entry.is_online
      }"
    >
      Online
    </v-button>
    <v-button
      v-else
      :request="setPublic"
      class="btn"
      :class="{
        'btn-warning': !entry.is_public,
        'btn-success': entry.is_public
      }"
    >
      18>
    </v-button>
    <v-button
      :request="setPrimary"
      :disabled="entry.is_erotic"
      class="btn"
      :class="{
        'btn-warning': !entry.is_primary,
        'btn-success': entry.is_primary
      }"
    >
      <i v-if="entry.is_image" class="fas fa-image"></i>
      <i v-if="entry.is_audio" class="fas fa-headphones"></i>
      <i class="fas fa-star"></i>
    </v-button>
  </div>
</template>

<script lang="babel">
export default {
  data() {
    return {
    }
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
    isFake: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  methods: {
    changeMedia(url) {
      return new Promise(resolve => {
        this.$http.post(url).then((response) => {this.$bus.$emit('media-changed', response.data); resolve();})
      });
    },
    setPrimary() {
      return this.changeMedia(this.entry.primary_url)
    },
    toggleErotic() {
      return this.changeMedia(this.entry.erotic_url)
    },
    setPublic() {
      return this.changeMedia(this.entry.public_url)
    },
    toggleOnline() {
      return this.changeMedia(this.entry.online_url)
    },
  }
}
</script>
